<template>
  <div class="avue-ueditor">
    <div :id="id" />
    <div v-if="show"
        class="wangEditor_html-content">
      <div class="wangEditor_html-header">
        <span class="wangEditor_html-close"
              @click="show=false">x</span>
      </div>
      <textarea v-model="html"/>
    </div>
  </div>
</template>
<script>

import {HTMLFormat} from './upload/util'
import {uploadOSS} from '../../utils/oss'
import E from 'wangeditor'
export default {
  props: {
    id: {
      type: String,
      default: () => {
        return 'avue-ueditor-' + Math.ceil(Math.random() * 100)
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      text: '',
      html: '',
      show: false,
      editor: '',
      imgUpdata: require("../../assets/imgs/updata.png"),
      uploadType: "oss", //判断是本地上传  "local" 或 oss 直传 "oss"
    }
  },
  computed: {
    domId () {
      return '#' + this.id
    },
    imgFlag () {
      return this.img.url == ''
    },
    isImg () {
      return this.img.obj.src
    },
    urlKey () {
      return this.props.url || 'url'
    },
    isQiniuOSS () {
      return this.oss === 'qiniu'
    },
    isAliOSS () {
      return this.oss === 'ali'
    },
  },
  watch: {
    disabled (val) {
      if (val) {
        this.editor.disable()
      } else {
        this.editor.enable()
      }
    },
    show (val) {
      if (val === false) {
        this.$emit('input', HTMLFormat(this.html))
      }
    },
    value (newVal) {
      console.log(newVal)
      if (this.editor) {
        if (newVal && newVal !== this.text) {
          this.text = newVal
          this.editor.txt.html(newVal)
        } else if (!newVal) {
          this.text = ''
          this.editor.txt.html('')
        }
      }
    },
  },
  mounted () {
    this.initEdit()
    // console.log(this.options)
  },
  methods: {
    initEdit () {
      const { BtnMenu } = E;
      var _this = this;
      // 上传附件功能
      // 第一，菜单 class ，Button 菜单继承 BtnMenu class
      class FileMenu extends BtnMenu {
        constructor(editor) {
          // data-title属性表示当鼠标悬停在该按钮上时提示该按钮的功能简述
          const $elem = E.$(
            // 这里使用opacity: 0将上传文件不显示，代替使用img显示，但input仍在img上方，在点击图标时，会弹出文件选择页面
            `<div class="w-e-menu" data-title="上传文件">
                      <div style="width: 16px;height: 16px;display: flex;cursor: pointer;"><img src="${_this.imgUpdata}" style="width: 16px;height: 16px;display: flex;cursor: pointer;"/>
                      <input type="file" style="opacity: 0;width: 16px;height: 16px;position: absolute;" multiple="multiple"  onchange="handleFileChange(this)"/></div>
                  </div>`
          );
          super($elem, editor);
        }
        // 菜单点击事件
        clickHandler() {
          // 做任何你想做的事情
        }
        tryChangeActive() {
          // 激活菜单
          // 1. 菜单 DOM 节点会增加一个 .w-e-active 的 css class
          // 2. this.this.isActive === true
          this.active();
        }
      }

      // 菜单 key ，各个菜单不能重复
      const menuKey = "fileMenuKey";

      // 注册菜单
      E.registerMenu(menuKey, FileMenu);      
      window.handleFileChange = this.handleFileChange
      this.editor = new E(this.domId)
      window.wangEditor = E
      this.editor.config.zIndex = 100
      this.editor.config.menuTooltipPosition = 'down'
      this.editor.config.placeholder = this.placeholder
      this.editor.config.showFullScreen = true
      // this.editor.customConfig.pasteFilterStyle = false
      this.editor.config.onfocus = () => {
        this.$emit('focus', this.text)
      }
      this.editor.config.onblur = (html) => {
        this.$emit('blur', html)
      }
      this.editor.config.onchange = (html) => {
        this.text = html
        this.$emit('input', this.text)
      }
      this.editor.config.emotions = [
        {
          title: 'emoji',  // tab 的标题
          type: 'emoji', // 'emoji' / 'image'
          // emoji 表情，content 是一个数组即可
          content: '😀 😃 😄 😁 😆 😅 😂 😊 😇 🙂 🙃 😉 😓 😪 😴 🙄 🤔 😬 🤐'.split(/\s/),
        }
      ]
            //上传视频
      this.editor.config.uploadVideoServer = '/verification/file'
      this.initUploadImg()
      this.initVideo()
      this.editor.config = Object.assign(
        this.editor.config,
        this.customConfig
      )
      this.editor.create()
      this.initPlugins()
      if (this.disabled === true) this.editor.disable()
      this.editor.txt.html(this.value)
    },
    async handleFileChange(e) {
      var that = this;
      if (that.uploadType == "oss") {
        uploadOSS(e.files[0]).then((res) => {
          that.editor.txt.append('<a target="_blank" style="color:blue" download href=\'' +  res + "'>" + res +"</a><br>");
        });
      } else {
          var formData = new FormData();
          formData.append("file", e.files[0]);
          formData.append("moduleName", "img");
          this.$Apis.verificationFile(formData).then((res) => {
            if (res.code == 200) {
              that.editor.txt.append('<a target="_blank" style="color:blue" download href=\'' +  res.data +"'>" +  res.data +"</a><br>");
            } else {
              this.$message.warning(res.msg);
            }

            loading.close();
          });
      }
    },    
    async initVideo() {
      this.editor.config.customUploadVideo = (file, insert) => {
        if (this.uploadType == "oss") {
          const loading = this.$loading({
          lock: true,
          text: '上传中，请稍后',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
          uploadOSS(file[0]).then((res) => {
            insert(res);
            loading.close();
          });
        } else {
          var formData = new FormData();
          formData.append("file",file[0]);
          formData.append("moduleName", file[0].name.split('.')[0]);
          this.$Apis.verificationFile(formData).then(res=>{
            if(res.code == 200){
              insert('http://xc-test.yafco.com:8765' + res.data);
            }else{
              this.$message.warning(res.msg);
            }
            loading.close();
          })          
        }
      };
    },      
    async initUploadImg() {
      this.editor.config.customUploadImg = (file, insert) => {
        if (this.uploadType == "oss") {
          uploadOSS(file[0]).then((res) => {
            insert(res);
          });
        } else {
          var formData = new FormData();
          formData.append("file",file[0]);
          formData.append("moduleName", "img");
          this.$Apis.verificationImg(formData).then(res=>{
            if(res.code == 200){
              insert(res.data);
            }else{
              this.$message.warning(res.msg);
            }
            loading.close();
          })          
        }
      };
    },
    getUEContent () {
      return this.editor.txt.html()
    },
    initPlugins () {
      E.views = {
        init: function (editorSelector) {
          var dom = document.createElement("div")
          dom.innerHTML = `<div class="w-e-menu" data-title="源代码" onclick="window.wangEditor.views.toggleFullscreen()" >
                  <span class="wangEditor_html" >
                  Html
                  </span>
              </div>`
          document.querySelector(editorSelector + ' .w-e-toolbar').append(dom)
        },
        toggleFullscreen: () => {
          this.html = HTMLFormat(this.value)
          this.show = true
        },
      }
      E.views.init(this.domId)
    },
  },
}
</script>
<style>
.wangEditor_html {
  color: #999;
  font-size: 14px;
  font-weight: bold;
}
/* .avue-ueditor .w-e-text-container {
} */
.wangEditor_html-content {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2048;
  padding: 0 20px 20px 20px;
  background-color: #fff;
  box-sizing: border-box;
}
.wangEditor_html-content textarea {
  width: 100%;
  height: 100%;
  border-color: #ccc;
  border-radius: 5px;
  padding: 5px;
}
.wangEditor_html-header {
  padding: 5px 0;
  text-align: right;
}
.wangEditor_html-close {
  color: #333;
  font-weight: bold;
  font-size: 22px;
}
</style>
